import { useState } from "react";
import clsx from "clsx";

interface ExpandableTextProps {
    text: string;
    maxLength?: number;
    className?: string;
}

export const ExpandableText = ({
    text,
    maxLength = 500,
    className,
}: ExpandableTextProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!text) {
        return <span className={clsx(className, "body-s subdued")}>-</span>;
    }

    const shouldTruncate = text.length > maxLength;

    if (!shouldTruncate) {
        return (
            <span className={clsx(className, "body-s subdued")}>{text}</span>
        );
    }

    const displayText = isExpanded ? text : `${text.slice(0, maxLength)}...`;

    return (
        <span className={clsx(className, "body-s subdued")}>
            {displayText}{" "}
            <span
                role="button"
                onClick={() => setIsExpanded(!isExpanded)}
                tabIndex={0}
                className="text-link"
            >
                {isExpanded ? "Show less" : "See more"}
            </span>
        </span>
    );
};
